<ng-container *clientScreen="let isDesktop = isDesktop">
	<div class="legacy-wrapper" [class.desktop]="isDesktop">
		<div class="modal" (click)="$event.stopPropagation()">
			<div class="flex-auto overflow-hidden w-full relative">
				<div class="top-0 left-0 w-full h-full absolute">
					<ng-content></ng-content>
				</div>
			</div>

			<div class="flex-none w-full flex items-center justify-center">
				<ng-content select="[footer]"></ng-content>
			</div>

			<ng-content select="[insideModal]"></ng-content>
		</div>
	</div>
</ng-container>
